/* Cart drawer suggestions: add a product, or swap the products of a kit
   for the kit itself. Delegated from the document so it keeps working
   after the drawer re-renders its contents, which it does on every cart
   change. After each change the drawer is asked to refresh, which brings
   the items, the free shipping line, the totals and these suggestions
   back in step. */
(function () {
  if (window.ojCartUpsell) return;
  window.ojCartUpsell = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  function refresh() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
  }

  document.addEventListener('click', function (evt) {
    var add = evt.target.closest('[data-oj-upsell-add]');
    var swap = evt.target.closest('[data-oj-kit-swap]');
    var btn = add || swap;
    if (!btn || btn.disabled) return;
    evt.preventDefault();
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    var job;
    if (add) {
      job = post('cart/add.js', { items: [{ id: Number(add.dataset.variantId), quantity: 1 }] });
    } else {
      /* The kit goes in first and the products come out after, so a
         failed add leaves the cart exactly as it was. Line keys do not
         change when another line is added, so the keys read at render are
         still the right ones. */
      var lines = JSON.parse(swap.dataset.lines || '[]');
      var out = {};
      lines.forEach(function (l) { out[l.key] = Math.max(0, l.qty - 1); });
      job = post('cart/add.js', { items: [{ id: Number(swap.dataset.kitVariant), quantity: 1 }] })
        .then(function () { return post('cart/update.js', { updates: out }); });
    }

    job.then(refresh).catch(function (err) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      refresh();
      console.log(err); // eslint-disable-line
    });
  });
})();
